/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Lottie from 'react-lottie';

import { ContainerStudies, ContainerLoading } from './style.js';
import Loading from '../../../assets/loading.json';
import Menu from '../../../components/Menu/index.js';
import Footer from '../../../components/Footer/index.js';
import AuthGuard from '../../../components/AuthGuard/index.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';

import api from '../../../services/api.js';

import ButtonDefault from '../../../components/ButtonDefault/index.js';
import InputDefault from '../../../components/InputDefault/index.js';
import ButtonAction from '../../../components/ButtonAction/index.js';
import ModalDelete from '../../../components/Modals/ModalDelete/index.js';
import ModalAdd from '../../../components/Modals/ModalAdd/index.js';
import ModalEdit from '../../../components/Modals/ModalEdit/index.js';

const GD2List = () => {
  document.title = 'Enermerco - GD2';

  const [isLoading, setIsLoading] = useState(true);

  const [gD2List, setGD2List] = useState([]);

  const [idDm007, setIdDm007] = useState('');
  const [gD2Year, setGD2Year] = useState('');

  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalGD2Desc, setModalGD2Desc] = useState('');
  const [modalNumber1, setModalNumber1] = useState('');
  const [modalNumber2, setModalNumber2] = useState('');

  const loadingAnimation = {
    loop: true,
    autoplay: true,
    animationData: Loading
  };

  const applyFilter = (idDm007, gD2Year) => {
    let url = 'gd2_transiction?';
    if (idDm007 !== '') {
      url += `&id=${idDm007}`;
    }
    if (gD2Year !== '') {
      url += `&ano=${gD2Year}`;
    }
    api
      .get(url)
      .then((response) => {
        setGD2List(response.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const searchFilter = useCallback(() => {
    applyFilter(idDm007, gD2Year);
  }, [idDm007, gD2Year]);

  const cleanFields = useCallback(() => {
    setIdDm007('');
    setGD2Year('');
    applyFilter('', '');
  }, [idDm007, gD2Year]);

  const deleteGD2 = useCallback(
    (id) => {
      console.log(id);
      api
        .delete(`gd2_transiction?id=${id}`)
        .then((response) => {
          setModalDelete(false);
          if (response.status === 200) {
            toast.success('GD2 transição removido com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          cleanFields();
          setModalDelete(false);
          toast.success(error);
        });
    },
    [modalDelete]
  );

  const addGD2 = useCallback(
    (_modalText, modalNumber1, modalNumber2, _modalNumber3) => {
      api
        .post(`gd2_transiction`, {
          NR_ANO: parseInt(modalNumber1.replace(',', '.')),
          PR_FIOB: parseFloat(modalNumber2.replace(',', '.').replaceAll('%', ''))
        })
        .then((response) => {
          setModalAdd(false);
          if (response.status === 201) {
            toast.success('GD2 adicionado com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          setModalAdd(false);
          toast.success(error);
        });
    },
    [modalAdd]
  );

  const editGD2 = useCallback(
    (_modalText, modalNumber1, modalNumber2, _modalNumber3, id, modalStatus) => {
      api
        .put(`energy_flag?id=${id}`, {
          NR_ANO: parseInt(modalNumber1.replace(',', '.')),
          PR_FIOB: parseFloat(modalNumber2.replace(',', '.').replaceAll('%', ''))
        })
        .then((response) => {
          setModalEdit(false);
          if (response.status === 201) {
            toast.success('GD2 alterado com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          setModalEdit(false);
          toast.success(error);
        });
    },
    [modalEdit]
  );

  useEffect(() => {
    applyFilter(idDm007, gD2Year);
  }, []);

  return (
    <>
      <AuthGuard />
      <Menu />
      {isLoading ? (
        <ContainerLoading>
          <Lottie options={loadingAnimation} style={{ width: '100%', height: 400 }} />
          <h1>Carregando GD2 Transição...</h1>
        </ContainerLoading>
      ) : (
        <Container>
          <ContainerStudies>
            <h2>Lista de GD2 Transição</h2>
            <ButtonDefault
              Width={'150px'}
              Margin={'0px 30px 30px 0px'}
              Text="Adicionar"
              onClick={() => {
                setModalAdd(true);
              }}
            />
            <h3>Filtros</h3>
            <Row>
              <Col xs={3}>
                <InputDefault
                  placeholder="Código GD2"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Código'}
                  value={`${idDm007}`}
                  onChange={(e) => setIdDm007(e.target.value)}
                  onKeyUp={(e) => {
                    if (e.key === 'Enter') {
                      applyFilter();
                    }
                  }}
                />
              </Col>
              <Col xs={6}>
                <InputDefault
                  placeholder="Número do Ano"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Número'}
                  value={`${gD2Year}`}
                  onChange={(e) => setGD2Year(e.target.value)}
                  onKeyUp={(e) => {
                    if (e.key === 'Enter') {
                      applyFilter();
                    }
                  }}
                />
              </Col>
            </Row>
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Buscar"
              onClick={searchFilter}
            />
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Limpar"
              onClick={() => {
                cleanFields();
              }}
            />
            <Table striped bordered hover variant="light">
              <thead>
                <tr>
                  <th style={{ width: '5%', textAlign: 'right' }}>Código</th>
                  <th style={{ width: '20%' }}>Número do ano</th>
                  <th style={{ width: '10%', textAlign: 'right' }}>Porcentagem de FIOB</th>
                  <th style={{ width: '5%', textAlign: 'center' }}>Ação</th>
                </tr>
              </thead>
              <tbody>
                {gD2List.map((gd2) => (
                  <tr>
                    <td style={{ textAlign: 'right' }}>{gd2.ID_DM007}</td>
                    <td>{gd2.NR_ANO}</td>
                    <td style={{ textAlign: 'right' }}>
                      {Number(gd2.PR_FIOB).toFixed(2).replace('.', ',')}
                    </td>
                    <td
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '45px',
                        justifyContent: 'center'
                      }}>
                      <ButtonAction
                        Action="Edit"
                        onClick={() => {
                          setIdDm007(gd2.ID_DM007);
                          setModalNumber1(Number(gd2.PR_FIOB).toFixed(2).replace('.', ','));
                          setModalEdit(true);
                        }}
                      />
                      <ButtonAction
                        Action="Remove"
                        onClick={() => {
                          setIdDm007(gd2.ID_DM007);
                          setModalDelete(true);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ContainerStudies>
          <ToastContainer />
          <ModalDelete
            modalOpen={modalDelete}
            handleClose={() => setModalDelete(false)}
            handleConfirm={deleteGD2}
            handleCancel={() => setModalDelete(false)}
            modalTitleText={`Deseja excluir o GD2 #${idDm007}?`}
            modalText={''}
            id={idDm007}
          />
          <ModalAdd
            modalOpen={modalAdd}
            handleClose={() => setModalAdd(false)}
            handleConfirm={addGD2}
            handleCancel={() => setModalAdd(false)}
            modalTitleText={'Adicionar novo GD2'}
            modalText={''}
            visibleText={false}
            visibleNumber1={true}
            visibleNumber2={true}
            placeHolderText={''}
            textLabel={''}
            number1Label={'Ano'}
            number2Label={'Porcentagem FIOB'}
            placeHolderNumber1={'Ano'}
            numberLabel1={'Ano'}
            placeHolderNumber2={'Porcentagem de FIOB'}
            numberLabel2={'Porcentagem de FIOB'}
          />
          <ModalEdit
            modalOpen={modalEdit}
            handleClose={() => setModalEdit(false)}
            handleConfirm={editGD2}
            handleCancel={() => setModalEdit(false)}
            modalTitleText={`Editar GD2 #${idDm007}`}
            visibleText={false}
            visibleNumber1={true}
            visibleNumber2={true}
            textLabel={''}
            id={idDm007}
            setModalText={setModalGD2Desc}
            modalText={modalGD2Desc}
            number1Label={'Ano'}
            number2Label={'Porcentagem de FIOB'}
            modalNumber1={modalNumber1}
            setModalNumber1={setModalNumber1}
            modalNumber2={modalNumber2}
            setModalNumber2={setModalNumber2}
            modalNumber3={''}
            setModalNumber3={() => {}}
          />
          <Footer />
        </Container>
      )}
    </>
  );
};

export default GD2List;
